import React from "react";
import './BlankTicket.css'
import { Link } from "react-router-dom";
export default function BlankTicket(props) {

    const lpParams = props.landingPageParams;

    return <div className="blankTicket card h-100 text-center border-0">
        <div className="card-body d-flex flex-column justify-content-center">
            {/* <i className="mahuti-circle"></i> */}

            {lpParams && <h5 className="header-cover-title mb-3 almoni_tzar_bold">{lpParams.Marketing_Banner_Title__c}</h5>}

            {lpParams && <h6 className="header-cover-title p-1">{lpParams.Marketing_Banner_SubTitle__c}</h6>}

            
        </div>
        <div className="card-footer rounded-0 p-0">   
            {lpParams && !lpParams.Marketing_Banner_Button_Show__c ? <Link to={lpParams.Marketing_Banner_Target_Url__c}>
                <button className="w-75 almoni_tzar_normal btn card-button btn-primary rounded-0 border-0 empty_card_btn" >{lpParams.Marketing_Banner_Button_Title__c}</button> {/*  w-90  */}
            </Link> : <div className="mt-5 pt-5"></div>  }
        </div>
    </div>
}